import { Auth } from 'aws-amplify';
import { endpoint } from '@goldspotdiscoveries/auth/lib/types';
import { apiUrls } from './TypeScript/process-constants';

export const endpoints = [
  ['Tessellation', 'tessellation'],
  ['Projects', 'projects'],
  ['Files', 'files'],
  ['Company', 'company'],
].map((value): endpoint => {
  const [name, endpointKey] = value;
  return {
    name,
    endpoint: apiUrls[endpointKey],
    custom_header: async () => {
      return {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        'Content-Type': 'application/json',
      };
    },
  };
});
